var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["bopis/product-bopis-info-icon.j2"] = require( "bopis/product-bopis-info-icon.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/bopis/product-bopis-messages.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"o-column o-extra-small--12 ";
output += runtime.suppressValue((!runtime.contextOrFrameLookup(context, frame, "forFamilyProduct")?"o-large--10 o-extra-large--9":""), env.opts.autoescape);
output += "\">";
if(env.getFilter("length").call(context, runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productBopis")),"availabilityMessages")) > 0 || runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"skuInfo")),"hasFlatRateSku")) {
frame = frame.push();
var t_3 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productBopis")),"availabilityMessages");
if(t_3) {var t_2 = t_3.length;
for(var t_1=0; t_1 < t_3.length; t_1++) {
var t_4 = t_3[t_1];
frame.set("productBopisMessage", t_4);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
if(runtime.memberLookup((t_4),"availabilityMessage")) {
if(runtime.memberLookup((t_4),"availabilityDate")) {
output += "<p class=\"c-product-bopis__p c-product-bopis__p--warning\" data-qa-product-msg-warning=\"";
output += runtime.suppressValue(env.getFilter("format_unix_timestamp").call(context, runtime.memberLookup((t_4),"availabilityDate"),runtime.contextOrFrameLookup(context, frame, "None"),"utc"), env.opts.autoescape);
output += "\">\n\n                        ";
output += runtime.suppressValue((lineno = 12, colno = 26, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, [runtime.memberLookup((t_4),"availabilityMessage"),runtime.makeKeywordArgs({"params": [env.getFilter("format_unix_timestamp").call(context, runtime.memberLookup((t_4),"availabilityDate"),runtime.contextOrFrameLookup(context, frame, "None"),"utc")]})])), env.opts.autoescape);
output += "\n\n                    </p>";
;
}
else {
output += "<p class=\"c-product-bopis__p c-product-bopis__p--warning\" data-qa-product-msg-warning>\n\n                        ";
output += runtime.suppressValue((lineno = 20, colno = 26, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, [runtime.memberLookup((t_4),"availabilityMessage")])), env.opts.autoescape);
output += "\n\n                    </p>";
;
}
;
}
;
}
}
frame = frame.pop();
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productBopis")),"flatRateCode")) {
var t_5;
t_5 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productBopis")),"flatRateCode") + "" + "_" + "" + runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"currency");
frame.set("flatRateSlug", t_5, true);
if(frame.topLevel) {
context.setVariable("flatRateSlug", t_5);
}
if(frame.topLevel) {
context.addExport("flatRateSlug", t_5);
}
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "quickshop")),"isOpen") || runtime.contextOrFrameLookup(context, frame, "forFamilyProduct")) {
output += "<p class=\"c-product-bopis__p c-product-bopis__p--flat-rate\"  data-qa-product-msg-warning>\n\n                    ";
output += runtime.suppressValue((lineno = 38, colno = 22, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, [runtime.contextOrFrameLookup(context, frame, "flatRateSlug"),runtime.makeKeywordArgs({"container": "shipRestrictionLocalization"})])), env.opts.autoescape);
output += "\n\n                </p>";
;
}
else {
output += "<p class=\"c-product-bopis__p\">\n\n                    <a class=\"c-product-bopis__p--flat-rate-link js-product-message__info--flat-rate\" href=\"#\" data-qa-product-msg-warning>\n\n                        ";
output += runtime.suppressValue((lineno = 48, colno = 26, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, [runtime.contextOrFrameLookup(context, frame, "flatRateSlug"),runtime.makeKeywordArgs({"container": "shipRestrictionLocalization"})])), env.opts.autoescape);
output += "\n\n                        ";
env.getTemplate("bopis/product-bopis-info-icon.j2", false, "product/templates/bopis/product-bopis-messages.j2", null, function(t_8,t_6) {
if(t_8) { cb(t_8); return; }
t_6.render(context.getVariables(), frame, function(t_9,t_7) {
if(t_9) { cb(t_9); return; }
output += t_7
output += "\n\n                    </a>\n\n                </p>";
})});
}
;
}
else {
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"skuInfo")),"hasFlatRateSku")) {
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "quickshop")),"isOpen") || runtime.contextOrFrameLookup(context, frame, "forFamilyProduct")) {
output += "<p class=\"c-product-bopis__p\" href=\"#\">\n\n                    ";
output += runtime.suppressValue((lineno = 64, colno = 22, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_non-flat-rate-message"])), env.opts.autoescape);
output += "\n\n                </p>";
;
}
else {
output += "<p class=\"c-product-bopis__p\">\n\n                    <a class=\"c-product-bopis__p--non-flat-rate js-product-message__info--flat-rate\" href=\"#\">\n\n                        ";
output += runtime.suppressValue((lineno = 74, colno = 26, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_non-flat-rate-message"])), env.opts.autoescape);
output += "\n\n                        ";
env.getTemplate("bopis/product-bopis-info-icon.j2", false, "product/templates/bopis/product-bopis-messages.j2", null, function(t_12,t_10) {
if(t_12) { cb(t_12); return; }
t_10.render(context.getVariables(), frame, function(t_13,t_11) {
if(t_13) { cb(t_13); return; }
output += t_11
output += "\n\n                    </a>\n\n                </p>";
})});
}
;
}
;
}
;
}
output += "\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/bopis/product-bopis-messages.j2"] , dependencies)